import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

export default function OFEPrograms() {
  const { user } = useAuth();
  const [selectedId, setSelectedId] = useState(null);
  const { data: programs, loading } = useOFEFetch('/ofe/programs', user);
  const { data: bom } = useOFEFetch(selectedId ? `/ofe/programs/${selectedId}/bom` : null, user, [selectedId]);
  const { data: reqs } = useOFEFetch(selectedId ? `/ofe/programs/${selectedId}/design-requirements` : null, user, [selectedId]);

  const selected = (programs || []).find(p => p.id === selectedId);

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-xl font-bold text-white">Program Design Requirements</h1>

      {loading && <div className="text-gray-400">Loading programs...</div>}

      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-1 space-y-2">
          {(programs || []).map(p => (
            <button key={p.id} onClick={() => setSelectedId(p.id)}
              className={`w-full text-left p-3 rounded-lg border transition-colors ${selectedId === p.id ? 'border-blue-500 bg-blue-900/20' : 'border-gray-700 bg-gray-800 hover:border-gray-500'}`}>
              <div className="text-white font-semibold text-sm">{p.name}</div>
              <div className="text-gray-400 font-mono text-xs">{p.program_code}</div>
              {p.mw_per_block && <div className="text-blue-400 text-xs mt-1">{p.mw_per_block} MW/block</div>}
              <span className={`text-xs px-1.5 py-0.5 rounded mt-1 inline-block ${p.status === 'active' ? 'bg-green-900/40 text-green-400' : 'bg-gray-700 text-gray-400'}`}>{p.status}</span>
            </button>
          ))}
          {!programs?.length && !loading && <div className="text-gray-500 text-sm">No programs</div>}
        </div>

        <div className="col-span-2 space-y-4">
          {selected ? (
            <>
              <div className="bg-gray-800 border border-gray-700 rounded-lg p-4">
                <h2 className="text-white font-bold text-lg">{selected.name}</h2>
                <div className="text-gray-400 text-sm mt-1">{selected.description || 'No description'}</div>
                {(selected.equipment_types || []).length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-3">
                    {selected.equipment_types.map(t => (
                      <span key={t} className="bg-blue-900/30 text-blue-300 text-xs px-2 py-1 rounded">{t}</span>
                    ))}
                  </div>
                )}
              </div>

              {bom?.length > 0 && (
                <div className="bg-gray-800 border border-gray-700 rounded-lg overflow-hidden">
                  <div className="bg-gray-900 px-4 py-2 text-gray-300 font-semibold text-sm">Bill of Materials</div>
                  <table className="w-full text-sm">
                    <thead className="text-gray-400 border-b border-gray-700">
                      <tr><th className="text-left px-4 py-2">Equipment Type</th><th className="text-right px-4 py-2">Qty/Block</th><th className="text-left px-4 py-2">Lead Time</th></tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                      {bom.map(b => (
                        <tr key={b.id}>
                          <td className="px-4 py-2 text-white">{b.equipment_type}</td>
                          <td className="px-4 py-2 text-right text-blue-400">{b.qty_per_block}</td>
                          <td className="px-4 py-2 text-gray-300 text-xs">{b.lead_time_days ? `${b.lead_time_days}d` : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {reqs?.length > 0 && (
                <div className="space-y-2">
                  <h3 className="text-white font-semibold">Design Requirements</h3>
                  {reqs.map(r => (
                    <div key={r.id} className="bg-gray-800 border border-gray-700 rounded p-3">
                      <div className="flex items-center gap-2">
                        <span className="text-xs px-2 py-0.5 rounded-full bg-gray-700 text-gray-300">{r.req_type}</span>
                        <span className="text-white font-semibold text-sm">{r.title}</span>
                        <span className={`ml-auto text-xs px-1.5 py-0.5 rounded ${r.status === 'open' ? 'bg-blue-900/40 text-blue-400' : 'bg-green-900/40 text-green-400'}`}>{r.status}</span>
                      </div>
                      {r.body && <p className="text-gray-300 text-sm mt-1">{r.body}</p>}
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div className="flex items-center justify-center h-48 text-gray-500">Select a program to view details</div>
          )}
        </div>
      </div>
    </div>
  );
}
